<template>
	<div class="full-page login-page">
		<div class="content">
			<div class="container">
				<div class="col-lg-4 col-md-6 ml-auto mr-auto" v-if="!is_d_none">
				<!--form @submit.prevent="onLogin()"-->
				<form @submit.prevent="$GVO.Login()">
					<card class="card-login card-white">
						<template v-slot:header>
							<img src="/img/card-primary.png" alt="" />
							<h1 class="card-title">Вход</h1>
						</template>

						<div>
							<base-input
							v-validate="'required|min:2'"
							name="login"
							:error="getError('login')"
							v-model="$GVO.login"
							placeholder="login"
							addon-left-icon="tim-icons icon-single-02"
							>
							</base-input>

							<base-input
							v-validate="'required|min:3'"
							name="password"
							:error="getError('password')"
							v-model="$GVO.password"
							type="password"
							placeholder="Password"
							addon-left-icon="tim-icons icon-lock-circle"
							>
							</base-input>
							<div v-if="bLoginFailed" class="alert alert-danger">Не правильный логин или пароль!</div>
						</div>

						<template v-slot:footer>
							<base-button native-type="submit" type="primary" class="mb-3" size="lg" block @click="$GVO.Login();">Вход</base-button>
						</template>
					</card>
				</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {eventEmitter} from "src/plugins/globalComponents.js";
export default {
	name: 'Login',
	
	data() {
		return {
			is_d_none:true,
			bLoginFailed: false,
		};
	},
	methods: {
		getError(fieldName) {
			return this.errors.first(fieldName);
		},
		toggleNavbar() {
			document.body.classList.toggle('nav-open');
		},
		closeMenu() {
			document.body.classList.remove('nav-open');
			document.body.classList.remove('off-canvas-sidebar');
		},
		onLogin(){
			this.bLoginFailed = false;
			this.$GVO.Login();
		},
		onLoginFailed(){
			this.bLoginFailed = true;
		}
	},
	created() {
		eventEmitter.$on('LOGIN_FAILED',this.onLoginFailed);
		//console.log(this.$GVO.isLogined);
		if(this.$GVO.isLogined){location.href='/data';}else{this.is_d_none=false;}
		//alert(this.cu);
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('LOGIN_FAILED',this.onLoginFailed);
	},
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
